import React from "react";
import { NavLink } from "react-router-dom";
import Logo from "./Logo";
import Quote from "./Quote";

class Navigation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            navToggled: false
        };
    }

    handleNavigationToggle = () => {
        this.setState(state => ({
            ...state,
            ...{ navToggled: !this.state.navToggled }
        }));
    };

    render() {
        const { onSearch, totalFavorites, totalWatched } = this.props;
        return (
            <div>
                <Logo />
                <Quote />
                <div className="header">
                    <nav className="menu" style={{ lineHeight: "20px" }}>
                        <div className="menu-item">
                            <NavLink to="/">
                                <span className="icon-home3" />&nbsp; Home
                            </NavLink>
                        </div>
                        <div className="menu-item">
                            <NavLink to="/dashboard">
                                <span className="icon-users" />&nbsp; Dashboard
                                ({`F-${totalFavorites}, W-${totalWatched}`})
                            </NavLink>
                        </div>
                        <div className="menu-item">
                            <NavLink to="/importexport">
                                <span className="icon-note-important" />&nbsp;
                                Import/Export
                            </NavLink>
                        </div>
                        <div className="menu-item">
                            <input
                                placeholder="Search movies here .."
                                className="inputTextNavigation"
                                onKeyPress={evt => {
                                    if (evt.key === "Enter") {
                                        onSearch(evt.target.value);
                                    }
                                }}
                            />
                        </div>
                        <div
                            className="menu-item"
                            hidden={!this.state.navToggled}
                        >
                            <button onClick={this.handleNavigationToggle}>
                                ☰
                            </button>
                        </div>
                    </nav>

                    <div
                        className="full-navigation"
                        style={{
                            display: this.state.navToggled ? "flex" : "none"
                        }}
                    >
                        <div className="menu-item">
                            <input
                                placeholder="Search movies here .."
                                className="inputTextNavigation"
                                onKeyPress={evt => {
                                    if (evt.key === "Enter") {
                                        onSearch(evt.target.value);
                                    }
                                }}
                            />
                        </div>

                        <div className="menu-item">
                            <div className="menu-item">
                                <NavLink to="/">
                                    <span className="icon-home3" />&nbsp; Home
                                </NavLink>
                            </div>
                            <div className="menu-item">
                                <NavLink to="/dashboard">
                                    <span className="icon-users" />&nbsp;
                                    Dashboard ({`F-${totalFavorites}, W-${totalWatched}`})
                                </NavLink>
                            </div>
                            <div className="menu-item">
                                <NavLink to="/importexport">
                                    <span className="icon-note-important" />&nbsp;
                                    Import/Export
                                </NavLink>
                            </div>
                            <div className="menu-item closebtn">
                                <button onClick={this.handleNavigationToggle}>
                                    ☰
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation.js